import marketsConfig from "config/markets.json"

export function getAllCountries() {
  return Object.values(marketsConfig).flatMap((countries) => countries)
}
